import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const MissingTemplateDialogBody = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('warrant.grid.missingTemplate.message.line1')}
      <br />
      {t('warrant.grid.missingTemplate.message.line2')}
    </Fragment>
  );
};

export default MissingTemplateDialogBody;
